import $api from '@/utils/api';
import Logger from '@/utils/logger';

export default {
  async getThemes(sectorId) {
    const response = await $api.get(`/sectors/${sectorId}/themes`);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },

  async getTheme(themeId) {
    const response = await $api.get(`/themes/${themeId}`);

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async getThemeForTopic(topicId) {
    const topicResponse = await $api.get(`/topics/${topicId}`);

    if (!topicResponse.success) {
      return { record: null };
    }

    const themeResponse = await this.getTheme(topicResponse.record.theme_id);
    return themeResponse.success ? themeResponse : { record: null };
  },
};
